
export default function TheFutureOf() {

    return (
        <div className="max-w-[924px] mx-auto text-center">
            <h1 className="px-2.5 text-[70px] font-extralight mobil-heading">The Future of</h1>
            <h1 className="px-2.5 text-[70px] text-[#84D1FF] font-black mobil-heading">Private Jet Transactions</h1>
            <div className="mx-[17px] flex flex-col gap-[30px] bg-[#1A1E27] items-center mt-[20px] py-[32px] px-[58px] rounded-2xl mobile-fp-space">
                <p className="text-[30px] font-semibold">Welcome to the future of private jet transactions</p>
                <p className="text-[18px] font-normal max-w-[572px]">Enhance your aviation service with our easy-to-use crypto payment
                    solution. We handle everything! We ensure hassle-free transactions
                    with our Trust Screen and Protect certificate and full compliance
                    support, no crypto expertise needed. Upgrade to a secure, seamless
                    financial experience with our integrated Digital Currency Department</p>
            </div>
        </div>
    )
}